<template>
  <div class="footer">
    <div class="fcont">
      <div class="left">
        <div class="theicon">
          <img
            style="max-width: 276px; width: 276px"
            @click="topath('/')"
            src="http://shanghai-siggraph.oss-cn-hangzhou.aliyuncs.com/admin/images/20231016/siggraph logo-03 (2).svg"
            alt=""
            class="icon"
          />
        </div>
        <div class="detail">
          <div class="theleft">
            <div style="cursor: pointer" class="hand" @click="topath('/about')">
              {{ $t("header.About") }}
            </div>
            <div
              style="cursor: pointer"
              class="hand"
              @click="topath('/joinus')"
            >
              {{ $t("header.join") }}
            </div>

            <div
              style="cursor: pointer"
              class="hand"
              @click="topath('/contactus')"
            >
              {{ $t("header.contact") }}
            </div>
          </div>
          <div class="theright">
            <div
              style="cursor: pointer"
              class="hand"
              @click="topath('/information')"
            >
              {{ $t("header.information") }}
            </div>
            <div
              style="cursor: pointer"
              class="hand"
              @click="topath('/activity')"
            >
              {{ $t("header.activity") }}
            </div>
            <div
              style="cursor: pointer"
              class="hand"
              @click="topath('/committee')"
            >
              {{ $t("header.Core_personnel") }}
            </div>
          </div>
        </div>
      </div>
      <div class="right"></div>

      <div class="icons">
        <div class="le">
          <!-- <div class="icon">
            <img
              src="http://shanghai-siggraph.oss-cn-hangzhou.aliyuncs.com/admin/images/20231110/icon_wechat.svg"
              alt=""
            />
          </div>
          <div class="icon">
            <img
              src="http://shanghai-siggraph.oss-cn-hangzhou.aliyuncs.com/admin/images/20231110/icon_microblog.svg"
              alt=""
            />
          </div>
          <div class="icon">
            <img
              src="http://shanghai-siggraph.oss-cn-hangzhou.aliyuncs.com/admin/images/20231110/icon_qq.svg"
              alt=""
            />
          </div>
          <div class="icon">
            <img
              src="http://shanghai-siggraph.oss-cn-hangzhou.aliyuncs.com/admin/images/20231110/icon_twitter.svg"
              alt=""
            />
          </div> -->
          <div
            class="icon"
            @click="topaths('https://www.facebook.com/SHSIGGRAPH')"
          >
            <img
              src="http://shanghai-siggraph.oss-cn-hangzhou.aliyuncs.com/admin/images/20231110/icon_facebook.svg"
              alt=""
            />
          </div>
          <div
            class="icon"
            @click="
              topaths(
                'https://space.bilibili.com/441689651?spm_id_from=333.337.0.0'
              )
            "
          >
            <img
              style="width: 25px"
              src="http://shanghai-siggraph.oss-cn-hangzhou.aliyuncs.com/admin/images/20250213/哔哩哔哩-copy.svg"
              alt=""
            />
          </div>
        </div>
        <div class="ri">
          <div class="word">
            <div class="t1">
              Copyright © 上海 ACM SIGGRAPH 学会. 2016 • All rights reserved.
            </div>
            <!-- <div class="t2">
              Theme By
              <span style="cursor: pointer; text-decoration: underline"
                >wordpress主题</span
              >. Powered by
              <span style="cursor: pointer; text-decoration: underline"
                >WordPress</span
              >. 京ICP证000007号
            </div> -->
          </div>
        </div>
      </div>
      <!-- <div>Copyright © 上海 ACM SIGGRAPH 学会. 2016 • All rights reserved.</div>
      <div>Theme By wordpress主题. Powered by WordPress. 京ICP证000007号</div> -->
    </div>
  </div>
</template>

<script setup>
import { useRouter, useRoute } from "vue-router";
const router = useRouter();
const route = useRoute();

const topath = (e, f) => {
  if (f) {
    router.push({
      path: e,
      query: {
        type: f,
      },
    });
  } else {
    router.push(e);
  }
};
const topaths = (e) => {
  window.open(e, "_blank"); // _blank 会在新窗口或标签页中打开
};
</script>

<style lang="scss" scoped>
@import "@/sass/index.scss";
.footer {
  background: #4155d9;
  @include fontstyle(#fff, 16px, 400, auto);
  padding: 25px;
  line-height: 26px;
  .word {
    max-width: 1176px;
    margin: 0 auto;
    display: flex;
    .t1 {
      text-align: left;
      // font-size: 16px;
      font-size: 12px;
      opacity: 0.5;
      // margin-top: 95px;
    }
    .t2 {
      text-align: left;
      // font-size: 16px;
      font-size: 12px;
      opacity: 0.5;
    }
  }

  .fcont {
    max-width: 1176px;
    margin: 0 auto;
    padding: 25px 0 0px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .left {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .icon {
        display: flex;
        cursor: pointer;
        &:hover {
          opacity: 0.5;
        }
      }
      .detail {
        // display: flex;
        font-size: 18px;
        width: 40%;
        .theleft {
          display: flex;
          justify-content: space-between;
          margin-bottom: 21px;
        }
        .theright {
          display: flex;
          justify-content: space-between;
          :nth-child(1) {
            // margin-right: 180px;
          }
        }
      }
    }
    .right {
      width: 100%;
      height: 2px;
      background: #fff;
      margin: 39px 0px 20px;
      opacity: 0.5;
      // display: flex;
      // font-size: 24px;
      // line-height: 28px;
      // .theleft {
      //   margin-right: 136px;
      //   text-align: left;
      //   :nth-child(n) {
      //     margin-bottom: 32px;
      //     cursor: pointer;
      //     &:hover {
      //       text-decoration: underline;
      //     }
      //   }
      // }
      // .theright {
      //   :nth-child(n) {
      //     margin-bottom: 32px;
      //     cursor: pointer;
      //     &:hover {
      //       text-decoration: underline;
      //     }
      //   }
      // }
    }
    .icons {
      display: flex;
      justify-content: space-between;
      width: 100%;
      align-items: center;
      // margin-top: 30px;
      .icon {
        cursor: pointer;
        width: 32px;
        height: 32px;
        box-sizing: border-box;
        border: 1px solid #fff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 20px;
        &:hover {
          border: 1px solid #ed765c;
          img {
            // transition: all 0.5s;
            // transform: scale(1.25);
            // color: #ed765c;
            filter: brightness(0) saturate(10%) invert(61%) sepia(79%)
              saturate(2615%) hue-rotate(333deg) brightness(97%) contrast(98%);
          }
        }
      }
      .le {
        display: flex;
      }
      .ri {
        display: flex;
      }
    }
  }
}
@media screen and (max-width: 1176px) {
}
@media screen and (max-width: 968px) {
  .footer {
    .fcont {
      flex-direction: column;
      padding-top: 40px;
      .left {
        flex-direction: column;
        .theicon {
          align-self: baseline;
          width: 220px !important;
          img {
            width: 100% !important;
          }
        }
        img {
        }
        .detail {
          margin-top: 20px;
          width: 100%;
          .theleft {
            margin-right: 0px !important;
          }
          .theright {
            justify-content: space-between;
            :nth-child(1) {
              // margin-right: 120px;
            }
          }
        }
        // margin-bottom: 60px;
      }
      .icons {
        flex-direction: column;
        .ri {
          margin-top: 10px;
          .word {
            flex-direction: column;
            .t1 {
              font-size: 10px;
            }
            .t2 {
              font-size: 10px;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 520px) {
  .theleft {
    margin-right: 30px !important;
  }
}
</style>
